var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.EmptyView,{attrs:{"name":_setup.t('spreed', 'The conversation does not exist'),"description":_setup.t('spreed', 'Join a conversation or start a new one!')},scopedSlots:_vm._u([{key:"icon",fn:function(){return [_c(_setup.IconMagnify)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }